import { AddCircleOutlineRounded, RemoveCircleOutline } from "@mui/icons-material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HistoryIcon from "@mui/icons-material/History";
// import SuccessMessageComponent from "../../components/SuccessMessageComponent";
import SuccessMessageComponent from "../components/SuccessMessageComponent";
import {
    Box,
    Breadcrumbs,
    Button,
    Card,
    CardContent,
    Grid,
    IconButton,
    Link,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    styled,
    tableCellClasses,
    tooltipClasses,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ERoles, formatIndianCurrency } from "../../config";
import useAuth from "../../hooks/useAuth";
import { apiGatewayAxiosInstance } from "../../utils/axios";
import TablePaginationShowPage from "../../utils/tablePagination";
import FetchingSpinner from "../components/FetchingSpinner";
import NoRecords from "../components/NoRecords";
import StyledMenu from "../tables/StyledMenu";
import TransactionHistoryModel from "../transactionManagement/TransactionHistoryModel";
import DeductRechargeModal from "./DeductRechargeModal";
import ManageRechargeFilter from "./ManageRechargeFilter";
import RechargeModal from "./RechargeModal";
import HandleChangeBillingType from "./HandleChangeBillingType";
import MaxBalanceLimitModel from "./MaxBalanceLimitModel";
import RefreshButton from "../../utils/refreshButton";

dayjs.extend(utc);

const StyledTableCellSticky = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 20,
        // backgroundColor: theme.palette.common.lightBlue,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 17,
        backgroundColor: theme.palette.common.white,
    },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontWeight: 600,
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
        padding: "10px !important",
        width: "20vw",
    },
    [`&.${tableCellClasses.body}`]: {
        padding: "10px !important",
        fontSize: 14,
    },
    [`&.${tableCellClasses.head.tr}`]: {
        backgroundColor: "#79E0EE",
        width: "45vw",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
    },

    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const BootstrapTooltip = styled(({ className, ...props }) => <Tooltip {...props} arrow classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
        fontSize: 14,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: 14,
    },
}));

const ListRecharge = ({ roleName, setRoleName, currentData, setCurrentData }) => {
    const { user } = useAuth();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [operationStatus, setOperationStatus] = useState({
        success: false,
        failed: false,
        message: "",
    });
    const [reload, setReload] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openAnchor = anchorEl?.id.split("@")[1];
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [masterBillingData, setMasterBillingData] = useState();
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState({
        recharge: false,
        deduct: false,
        filter: false,
        history: false,
        handleBillingType: false,
        maxBalanceLimit: false,
    });
    const [searchParams, setSearchParams] = useState({
        name: "",
        billingType: "",
    });
    const [roleToFetchTransactions, setRoleToFetchTransactions] = useState();

    const handleCloseSuccessMessage = () => {
        setOperationStatus({ success: false, failed: false, message: "" });
    };

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };
    const handleChangeRowsPerPage = event => {
        setPageSize(parseInt(event.target.value));
        setCurrentPage(0);
    };

    const handleClose = () => {
        handleCloseAncho();
        setOpen({
            recharge: false,
            deduct: false,
            filter: false,
            history: false,
            handleBillingType: false,
            maxBalanceLimit: false,
        });
    };

    const onClickRecharge = data => {
        setCurrentData(data);
        setOpen({
            recharge: true,
            deduct: false,
            filter: false,
            history: false,
            handleBillingType: false,
        });
    };

    const onClickDeduct = data => {
        setCurrentData(data);
        setOpen({
            recharge: false,
            deduct: true,
            filter: false,
            history: false,
        });
    };

    const onClickChangeBillingType = data => {
        setCurrentData(data);
        setOpen({
            recharge: false,
            deduct: false,
            filter: false,
            history: false,
            handleBillingType: true,
        });
    };

    const onClickViewOrg = data => {
        setCurrentData(data);
        setRoleName(ERoles.RESELLER_ADMIN);
    };

    const onClickMaxBalanceLimit = data => {
        setCurrentData(data);
        setOpen({
            recharge: false,
            deduct: false,
            filter: false,
            history: false,
            handleBillingType: false,
            maxBalanceLimit: true,
        });
    };

    const onClickRechargeFilter = () => {
        setOpen({
            recharge: false,
            deduct: false,
            filter: true,
            history: false,
            handleBillingType: false,
        });
    };

    const onClickViewHistory = data => {
        setCurrentData(data);
        setRoleToFetchTransactions(roleName === ERoles.SUPER_ADMIN ? ERoles.RESELLER_ADMIN : ERoles.ORG_ADMIN);
        setOpen({
            recharge: false,
            deduct: false,
            filter: false,
            history: true,
            handleBillingType: false,
        });
    };

    const handleCloseAncho = () => {
        setAnchorEl(null);
    };

    const reloadList = () => {
        setReload(!reload);
    };

    const handleClickSearch = async searchParams => {
        setLoading(true);
        setCurrentPage(0);
        setPageSize(10);
        setSearchParams(searchParams);
        const response = await apiGatewayAxiosInstance.get(`/user_management/master-billing/get-all-master-billing`, {
            params: {
                currentPage: 1,
                pageSize: 10,
                name: searchParams.name,
                billingType: searchParams.billingType,
                roleName: roleName,
                registryId: currentData?.registryId ?? user.registryId,
            },
        });
        setMasterBillingData(response.data.allCurrentMasterBillingDetails);
        setTotalCount(response.data.totalCount);
        setLoading(false);
        setLoading(false);
        handleClose();
    };

    const getMasterBillingDetails = async () => {
        try {
            setLoading(true);
            const response = await apiGatewayAxiosInstance.get(`/user_management/master-billing/get-all-master-billing`, {
                params: {
                    currentPage: currentPage + 1,
                    pageSize,
                    roleName,
                    registryId: currentData?.registryId ?? user.registryId,
                    name: searchParams.name,
                    billingType: searchParams.billingType,
                },
            });
            if (response.status === 200) {
                setMasterBillingData(response.data.allCurrentMasterBillingDetails);
                setTotalCount(response.data.totalCount);
                setLoading(false);
            }
        } catch (error) {
            let errorMessage = "Something Went Wrong!";
            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            dispatch(setOperationStatus({ failed: true, message: errorMessage }));
            setLoading(false);
        }
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const onClickBackButton = () => {
        setAnchorEl(null);
        setCurrentData(null);
        setRoleName(ERoles.SUPER_ADMIN);
    };

    useEffect(() => {
        getMasterBillingDetails();
    }, [pageSize, currentPage, roleName, reload]);

    return (
        <>
            <Box>
                <Grid mb={4} container sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <Grid item alignItems={"center"} gap={2}>
                        <Grid item display={"flex"} alignItems={"center"} gap={2}>
                            {roleName.toLowerCase() === ERoles.RESELLER_ADMIN && user.roleName.toLowerCase() === ERoles.SUPER_ADMIN ? (
                                <>
                                    {" "}
                                    <IconButton color="secondary" onClick={onClickBackButton} size="medium">
                                        <ArrowBackIosIcon sx={{ cursor: "pointer" }} />
                                    </IconButton>
                                    <Breadcrumbs aria-label="breadcrumb" fontSize="large">
                                        <Link
                                            underline="hover"
                                            color="inherit"
                                            className="breadcrumbItem"
                                            // href="/rcs-management/manage-bots/"
                                            onClick={onClickBackButton}
                                        >
                                            <Typography variant="h3">Recharge</Typography>
                                        </Link>
                                        <Typography variant="h3" color="text.primary">
                                            {currentData.data.resellerName}
                                        </Typography>
                                    </Breadcrumbs>
                                </>
                            ) : (
                                <Typography variant="h3">Recharge</Typography>
                            )}
                        </Grid>
                    </Grid>

                    <Grid item justifyContent={"end"}>
                        <RefreshButton loading={loading} onClick={reloadList} />
                        <Button variant="contained" onClick={onClickRechargeFilter} sx={{ marginLeft: "10px" }}>
                            Filter
                        </Button>
                    </Grid>
                </Grid>

                <Card className="border border-secondary-50 ">
                    <CardContent
                        sx={{
                            padding: 0,
                        }}
                    >
                        <Grid
                            sx={{
                                display: "flex ",
                                justifyContent: "left",
                                flexDirection: "column",
                            }}
                        >
                            {loading ? (
                                <FetchingSpinner />
                            ) : (
                                <>
                                    {masterBillingData && masterBillingData.length > 0 ? (
                                        <TableContainer
                                            component={Paper}
                                            className="table-container"
                                            sx={{
                                                overflowY: "scroll",
                                                overflowX: "hidden",
                                                width: "auto !important",
                                                maxHeight: "69vh",
                                            }}
                                        >
                                            <Table className="left" aria-label="table with sticky header" stickyHeader>
                                                <TableHead className="p-3 mb-2 row">
                                                    <TableRow>
                                                        <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                            <Typography fontSize={14}>Sr No</Typography>
                                                        </StyledTableCell>
                                                        {roleName.toLowerCase() === ERoles.RESELLER_ADMIN && (
                                                            <StyledTableCell align="left" className="col-1 tableHeaderFont">
                                                                <Typography fontSize={14}>Organization Name</Typography>
                                                            </StyledTableCell>
                                                        )}
                                                        {roleName.toLowerCase() === ERoles.SUPER_ADMIN && (
                                                            <StyledTableCell align="left" className="col-1 tableHeaderFont">
                                                                <Typography fontSize={14}>Reseller Name</Typography>
                                                            </StyledTableCell>
                                                        )}
                                                        <StyledTableCell align="left" className="col-1 tableHeaderFont">
                                                            <Typography fontSize={14}>Billing Type</Typography>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="left" className="col-1 tableHeaderFont">
                                                            <Typography fontSize={14}>Current Balance / Limit</Typography>
                                                        </StyledTableCell>
                                                        {/* <StyledTableCell align='left' className='col-1 tableHeaderFont'>
                                                                <Typography fontSize={14}>Recharge</Typography>
                                                            </StyledTableCell>
                                                            <StyledTableCell align='left' className='col-1 tableHeaderFont'>
                                                                <Typography fontSize={14}>Deduct</Typography>
                                                            </StyledTableCell>
                                                            <StyledTableCell align='left' className='col-1 tableHeaderFont'>
                                                                <Typography fontSize={14}>History</Typography>
                                                            </StyledTableCell>

                                                            {roleName.toLowerCase() === ERoles.SUPER_ADMIN &&
                                                                    (
                                                            <StyledTableCell align='left' className='col-1 tableHeaderFont'>
                                                                <Typography fontSize={14}>View Organizations</Typography>
                                                            </StyledTableCell>)} */}

                                                        <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                            <Typography fontSize={14}>Actions</Typography>
                                                        </StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {masterBillingData.map((data, index) => (
                                                        <StyledTableRow key={data.id || index}>
                                                            <StyledTableCell align="center">{currentPage * pageSize + index + 1}</StyledTableCell>
                                                            {roleName.toLowerCase() === ERoles.RESELLER_ADMIN && (
                                                                <StyledTableCell align="left">{data?.data?.orgName}</StyledTableCell>
                                                            )}
                                                            {roleName.toLowerCase() === ERoles.SUPER_ADMIN && (
                                                                <StyledTableCell align="left">{data?.data?.resellerName}</StyledTableCell>
                                                            )}

                                                            <StyledTableCell align="left">{data?.billingPaymentType}</StyledTableCell>
                                                            <StyledTableCell align="left">
                                                                {data?.billingPaymentType === "Postpaid" &&
                                                                    (data.capCheck
                                                                        ? formatIndianCurrency(data.maxBalanceLimit?.toFixed(2))
                                                                        : "No Limit")}
                                                                {data?.billingPaymentType === "Prepaid" &&
                                                                    formatIndianCurrency(data?.currentBalance?.toFixed(2))}
                                                            </StyledTableCell>
                                                            {/* <StyledTableCell align='left'>
                                                                    <Button
                                                                        disabled={data.billingPaymentType !== 'Prepaid'}
                                                                        onClick={() => {
                                                                            onClickRecharge(data);
                                                                        }}>
                                                                        <AddCircleOutlineRounded />
                                                                    </Button>
                                                                </StyledTableCell>
                                                                <StyledTableCell align='left'>

                                                                    <Button
                                                                        disabled={data.billingPaymentType !== 'Prepaid'}
                                                                        onClick={() => {
                                                                            onClickDeduct(data);
                                                                        }}>
                                                                        <RemoveCircleOutline />
                                                                    </Button>
                                                                </StyledTableCell>
                                                                <StyledTableCell align="left">
                                                                    <Tooltip title='View History'>
                                                                        <IconButton onClick={() => onClickViewHistory(data)}>
                                                                            <HistoryIcon color={"primary"} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </StyledTableCell>
                                                                {roleName.toLowerCase() === ERoles.SUPER_ADMIN &&
                                                                    (
                                                                        <StyledTableCell align="left">
                                                                        <Button

                                                                            onClick={() => {
                                                                                onClickViewOrg(data);
                                                                            }}>
                                                                            <RemoveCircleOutline />
                                                                        </Button>
                                                                        </StyledTableCell>

                                                                    )} */}
                                                            <StyledTableCell className="tableContentFont" align="center">
                                                                <IconButton
                                                                    id={`menu-button@${data._id}`}
                                                                    aria-controls={
                                                                        openAnchor === data._id ? `customized-menu@${data._id}` : undefined
                                                                    }
                                                                    aria-haspopup="true"
                                                                    aria-expanded={openAnchor === data._id ? "true" : undefined}
                                                                    variant="contained"
                                                                    // disableElevation
                                                                    onClick={handleClick}
                                                                >
                                                                    <MoreVertIcon />
                                                                </IconButton>
                                                                <StyledMenu
                                                                    id={`customized-menu@${data._id}`}
                                                                    MenuListProps={{
                                                                        "aria-labelledby": `menu-button@${data._id}`,
                                                                    }}
                                                                    anchorEl={anchorEl}
                                                                    open={openAnchor === data._id}
                                                                    onClose={handleCloseAncho}
                                                                >
                                                                    {data && data?.billingPaymentType !== "Postpaid" && (
                                                                        <MenuItem onClick={() => onClickRecharge(data)}>
                                                                            <IconButton title="View Details">
                                                                                <AddCircleOutlineRounded className="text-primary" />
                                                                            </IconButton>
                                                                            Recharge
                                                                        </MenuItem>
                                                                    )}
                                                                    {data && data?.billingPaymentType !== "Postpaid" && (
                                                                        <MenuItem onClick={() => onClickDeduct(data)}>
                                                                            <IconButton title="View Details">
                                                                                <RemoveCircleOutline className="text-primary" />
                                                                            </IconButton>
                                                                            Deduct
                                                                        </MenuItem>
                                                                    )}

                                                                    <MenuItem onClick={() => onClickChangeBillingType(data)}>
                                                                        <IconButton title="View Details">
                                                                            <CurrencyExchangeIcon className="text-primary" />
                                                                        </IconButton>
                                                                        Change Billing Type
                                                                    </MenuItem>

                                                                    {data && data?.billingPaymentType !== "Prepaid" && (
                                                                        <MenuItem onClick={() => onClickMaxBalanceLimit(data)}>
                                                                            <IconButton title="View Details">
                                                                                <CurrencyExchangeIcon className="text-primary" />
                                                                            </IconButton>
                                                                            Update Maximum Balance Limit
                                                                        </MenuItem>
                                                                    )}
                                                                    <MenuItem onClick={() => onClickViewHistory(data)}>
                                                                        <IconButton title="View Details">
                                                                            <HistoryIcon className="text-primary" />
                                                                        </IconButton>
                                                                        History
                                                                    </MenuItem>
                                                                    {roleName.toLowerCase() === ERoles.SUPER_ADMIN && (
                                                                        <MenuItem onClick={() => onClickViewOrg(data)}>
                                                                            <IconButton title="View Details">
                                                                                <VisibilityIcon className="text-primary" />
                                                                            </IconButton>
                                                                            View Organizations
                                                                        </MenuItem>
                                                                    )}
                                                                </StyledMenu>
                                                                {/* <Button
                                                                        size="small"
                                                                        sx={{ padding: "0px", margin: "0px" }}
                                                                        disabled={data.billingPaymentType !== 'Prepaid'}
                                                                        onClick={() => {
                                                                            onClickRecharge(data);
                                                                        }}> */}

                                                                {/* <Grid container gap={2} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                        <Grid item>
                                                                            <AddCircleOutlineRounded
                                                                                disabled={data.billingPaymentType !== 'Prepaid'}
                                                                                onClick={() => {
                                                                                    onClickRecharge(data);
                                                                                }}
                                                                                color="primary"
                                                                                sx={{ padding: "0px", margin: "0px", fontSize: "20px" }}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item>
                                                                            <RemoveCircleOutline
                                                                                color="primary"
                                                                                disabled={data.billingPaymentType !== 'Prepaid'}
                                                                                onClick={() => {
                                                                                    onClickDeduct(data);
                                                                                }}
                                                                                sx={{ fontSize: "20px" }}
                                                                            />

                                                                        </Grid>
                                                                        <Grid item>
                                                                            <Tooltip title='View History' sx={{ padding: "0px" }}>
                                                                                <IconButton onClick={() => onClickViewHistory(data)}>
                                                                                    <HistoryIcon color={"primary"} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </Grid>
                                                                    </Grid> */}

                                                                {/* </Button> */}
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    ) : (
                                        <NoRecords />
                                    )}
                                </>
                            )}
                        </Grid>
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "left",
                                placeContent: "space-between",
                            }}
                        >
                            <Grid
                                style={{
                                    marginTop: "20px",
                                    marginLeft: "10px",
                                }}
                            >
                                Total Records:{totalCount}
                            </Grid>
                            {masterBillingData && masterBillingData.length > 0 && (
                                <Grid mt={5} paddingLeft={5}>
                                    <TablePaginationShowPage
                                        rowsPerPageOptions={[5, 10, 25, 100]}
                                        colSpan={3}
                                        count={totalCount}
                                        rowsPerPage={pageSize}
                                        page={currentPage}
                                        slotProps={{
                                            select: {
                                                "aria-label": "Rows per page",
                                            },
                                            actions: {
                                                showFirstButton: true,
                                                showLastButton: true,
                                                slots: {
                                                    firstPageIcon: FirstPageRoundedIcon,
                                                    lastPageIcon: LastPageRoundedIcon,
                                                    nextPageIcon: ChevronRightRoundedIcon,
                                                    backPageIcon: ChevronLeftRoundedIcon,
                                                },
                                            },
                                        }}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </CardContent>

                    {open.recharge && (
                        <RechargeModal
                            open={open.recharge}
                            handleClose={handleClose}
                            currentData={currentData}
                            getMasterBillingDetails={getMasterBillingDetails}
                            setOperationStatus={setOperationStatus}
                        />
                    )}
                    {open.deduct && (
                        <DeductRechargeModal
                            open={open.deduct}
                            handleClose={handleClose}
                            currentData={currentData}
                            getMasterBillingDetails={getMasterBillingDetails}
                            setOperationStatus={setOperationStatus}
                        />
                    )}

                    {open.filter && (
                        <ManageRechargeFilter
                            open={open.filter}
                            handleClose={handleClose}
                            searchParams={searchParams}
                            setSearchParams={setSearchParams}
                            handleClickSearch={handleClickSearch}
                        />
                    )}
                    {open.history && (
                        <TransactionHistoryModel
                            open={open.history}
                            handleClose={handleClose}
                            currentData={currentData}
                            roleToFetchTransactions={roleToFetchTransactions}
                        />
                    )}
                    {open.handleBillingType && (
                        <HandleChangeBillingType
                            open={open.handleBillingType}
                            handleClose={handleClose}
                            currentData={currentData}
                            getMasterBillingDetails={getMasterBillingDetails}
                            setOperationStatus={setOperationStatus}
                        />
                    )}
                    {open.maxBalanceLimit && (
                        <MaxBalanceLimitModel
                            open={open.maxBalanceLimit}
                            handleClose={handleClose}
                            currentData={currentData}
                            getMasterBillingDetails={getMasterBillingDetails}
                            setOperationStatus={setOperationStatus}
                        />
                    )}
                </Card>
            </Box>
            {operationStatus.success && (
                <SuccessMessageComponent message={operationStatus.message} handleClose={handleCloseSuccessMessage} show={operationStatus.success} />
            )}
        </>
    );
};

export default ListRecharge;
